import Helper from "../Helper";

/**
 * This class represents button with animation of going from the bottom of viewport,
 * with condition when to show and not -- now only used for cart so the handle function
 * is not reusable, but this can be easily adjusted
 */
export default class ButtonWithAnimation {

  /**
   * Constructor of button with animation
   *
   * @param {String} name the name of wrapper of the button - div that is animated
   * @param {String} scrollTo name of the wrapper we want to scroll to after clicking
   */
    constructor(name, scrollTo)
    {
        this.scrollToButton = $('[data-'+name+']');
        this.scrollToElement = document.querySelector(scrollTo);
        this.priceElement = this.scrollToButton.find('[data-'+name+'Price]');

        this.init();
    }

    init()
    {
        $(document).ready(() => {
            if (this.scrollToButton.length > 0) {
                this.handleButtonShowingBasedOnViewport(this.scrollToElement);

                // event listener for scroll
                document.addEventListener('scroll', () => {
                    this.handleButtonShowingBasedOnViewport(this.scrollToElement)
                })

                // event listener for resize
                document.addEventListener('resize', () => {
                      this.handleButtonShowingBasedOnViewport(this.scrollToElement);
                })

                this.scrollToButton.click(() => {
                      this.scrollToDestination();
                })
            }
        });
    }

  /**
   * Function that scrolls to element when button is clicked
   */
    scrollToDestination()
    {
        Helper.scrollToElement(this.scrollToElement, -120, 0);
    }

  /**
   * Function that shows button that allows scrolling back to cart
   *
   * @param {Number} price - cart price
   */
    showButton(price = undefined)
    {
        if (price !== undefined) {
            this.updatePrice(price);
        }

        this.scrollToButton.css({
            'transform': 'translateY(0px)'
        });
    }

  /**
   * Function that hides button that allows scrolling back to cart
   */
    hideButton()
    {
        this.scrollToButton.css({
            'transform': 'translateY(120%)'
        });
    }

  /**
   * Function that handles showing button that allows scrolling back to cart based on position of cart in viewport
   *
   * @param {Element} cartSectionElement
   */
    handleButtonShowingBasedOnViewport(cartSectionElement)
    {
        if ($('[data-cart]').find('[data-cart-item]').length <= 0 || !Helper.isTabletOrLower()) {
            this.hideButton();
        } else {
            if (Helper.isInViewport(cartSectionElement)) {
                this.hideButton();
            } else {
                this.showButton();
            }
        }
    }

  /**
   * Function that updates cart price in the button
   *
   * @param {Number} price - cart price
   */
    updatePrice(price)
    {
        this.priceElement.html(Helper.formatPrice(price));
    }
}
